// extracted by mini-css-extract-plugin
export default {"App":"App_App__ugW8I","Anchor":"App_Anchor__7HdWr"};